(function($)
{

  $(document).ready( function()
  {
    window.onclick = function(event) {
      if (event.target.matches('[data-dropdown]')) {
        document.querySelectorAll("[data-dropdown]").forEach(dropdown => {
          dropdown.classList.toggle("active")
        })
      }
      else {
        document.querySelectorAll("[data-dropdown].active").forEach(dropdown => {
          dropdown.classList.remove("active")
        })
      }

      if (event.target.matches('[data-more-dropdown]')) {
        document.querySelectorAll("[data-more-dropdown]").forEach(dropdown => {
          dropdown.classList.toggle("active")
        })
      }
      else {
        document.querySelectorAll("[data-more-dropdown].active").forEach(dropdown => {
          dropdown.classList.remove("active")
        })
      }
      
      if (event.target.matches('[data-more-mobile-dropdown]')) {
        document.querySelectorAll("[data-more-mobile-dropdown]").forEach(dropdown => {
          dropdown.classList.toggle("active")
        })
      }
      else {
        document.querySelectorAll("[data-more-mobile-dropdown].active").forEach(dropdown => {
          dropdown.classList.remove("active")
        })
      }

      /*
      if (event.target.matches('[data-banner-x]')) {
        document.querySelectorAll("[data-banner-container]").forEach(dropdown => {
          dropdown.classList.toggle("active")
        })
      }
      */

    }
  });


})( jQuery );

